import { Formik, Form, Field, FieldArray, useFormikContext, useField, ErrorMessage } from 'formik';
import React, { useState, useEffect } from 'react';
import FormikControl from '../../../hoc/formikComponents/FormikControl'
import { useMutation, useQuery } from 'react-query'
import ToastInstance from '../../../hoc/NotificationSettings/ToastInstance'
import Fetcher from '../../../hoc/FetcherSetting/FetcherSetting'
import { useParams } from 'react-router';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { date } from 'yup/lib/locale';
import Select from 'react-select'
import * as AiIcons from 'react-icons/ai';
import * as Yup from 'yup'
import swal from '@sweetalert/with-react';
import { APIURL } from '../../../hoc/AxiosSetting/axios';
import axios from 'axios';

function EmsStage1AuditReport() {
    const history = useHistory();
    const [leadauditorList, setLeadauditorList] = useState([{
            label: "",
            value: ""
    }])
    const [assitAuditorList, setassitAuditorList] = useState([{
            label: "",
            value: ""
    }])
    const [technicalExpertList,setTechnicalExpertList] = useState([{
            label:"",
            value:""
    }])
    const options = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
      const options1 = [
        { key: 'Yes', value: 'Yes' },
        { key: 'No', value: 'No' }
      ]
    const yesNo = [
        { key: 'Select', value: '-' },
        { key: 'C', value: 'C' },
        { key: 'NC', value: 'NC' },
        { key: 'O', value: 'O' },
    ]
    const [initialValues, setInitialValues] = useState({
        id: "",
        orgCode: 0,
        address:"",
        siteofaddress:"",
        total:"",
        mobile:"",
        email:"",
        contactPersonName:"",
        scope:"",
        stageOneAudit:"",
        auditdate1:new Date(),
        stageTwoAudit:"",
        auditdate2:new Date(),
        dateofaudit:new Date(),
        dateofauditto:new Date(),
        auditobjective:"",
        briefaboutorg:"",
        areqquatedmandays:"",
        istherechangeemployee:"",
        istherechangescope:"",
        isthereanyinforevent:"",
        teamleader: "",
        teamleaderName: "",
        auditorOne: "",
        auditorOneName: "",
        auditorTwo: "",
        auditorTwoName: "",
        technicalexpert: "",
        auditcheckliststatus1:"C",
        remarkauditchecklist1:"",
        auditcheckliststatus2:"C",
        remarkauditchecklist2:"",
        auditcheckliststatus3:"C",
        remarkauditchecklist3:"",
        auditcheckliststatus4:"C",
        remarkauditchecklist4:"",
        auditcheckliststatus5:"C",
        remarkauditchecklist5:"",
        auditcheckliststatus6:"C",
        remarkauditchecklist6:"",
        auditcheckliststatus7:"C",
        remarkauditchecklist7:"",
        auditcheckliststatus8:"C",
        remarkauditchecklist8:"",
        auditcheckliststatus9:"C",
        remarkauditchecklist9:"",
        auditcheckliststatus10:"C",
        remarkauditchecklist10:"",
        auditcheckliststatus11:"C",
        remarkauditchecklist11:"",
        auditcheckliststatus12:"C",
        remarkauditchecklist12:"",
        briefaboutorg:"",
        teamleadervalue1:"Yes",
        teamleadervalue2:"Yes",
        teamleadervalue3:"Yes",
        teamleadervalue4:"Yes",
        teamleadervalue5:"Yes",
        teamleadervalue6:"Yes",
        teamleadervalue7:"Yes",
        teamleadervalue8:"Yes",
        teamleadervalue9:"Yes",
        recommededvalue1:"Yes",
        recommededvalue2:"Yes",
        recommededvalue3:"Yes",
        texchnicalarea:"",
        nonappofclauseifany:"",
        legalstatandregreqforcomp:""

    })
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        console.log("values", values)
        mutation.mutate(values)
    }
    const validationSchema = Yup.object({
    })
    const mutation = useMutation((params) => Fetcher('patch', '/api/rfq/patch/stage1auditreport14001', params), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Stage 1 Audit Report Data Added')
                //history.push("/" + localStorage.getItem("role") + '/viewauditteamproposal/' + data.data.response.orgCode);
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationgetCompanyDetails = useMutation((params) => Fetcher('get', '/api/rfq/get/orgdetails/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                var tempInitialValues = data.data.response;
                console.log("tempInitialValues", tempInitialValues)
                tempInitialValues.dateofaudit = Date.parse(data.data.response.dateofaudit) || null;
                tempInitialValues.auditdate1 = Date.parse(data.data.response.auditdate1) || null;
                tempInitialValues.auditdate2 = Date.parse(data.data.response.auditdate2) || null;
                tempInitialValues.teamleader = data.data.response.teamleader || "";
                tempInitialValues.teamleaderName = data.data.response.teamleaderName || "";
                tempInitialValues.auditorOne = data.data.response.auditorOne || "";
                tempInitialValues.auditorTwo = data.data.response.auditorTwo || "";

                tempInitialValues.technicalexpert = data.data.response.technicalexpert || "";
                tempInitialValues.auditcheckliststatus1 = data.data.response.auditcheckliststatus1 || "C";
                tempInitialValues.remarkauditchecklist1 = data.data.response.remarkauditchecklist1 || "";
                tempInitialValues.auditcheckliststatus2 = data.data.response.auditcheckliststatus2 || "C";
                tempInitialValues.remarkauditchecklist2 = data.data.response.remarkauditchecklist2 || "";
                tempInitialValues.auditcheckliststatus3 = data.data.response.auditcheckliststatus3 || "C";
                tempInitialValues.remarkauditchecklist3 = data.data.response.remarkauditchecklist3 || "";
                tempInitialValues.auditcheckliststatus4 = data.data.response.auditcheckliststatus4 || "C";
                tempInitialValues.remarkauditchecklist4 = data.data.response.remarkauditchecklist4 || "";
                tempInitialValues.auditcheckliststatus5 = data.data.response.auditcheckliststatus5 || "C";
                tempInitialValues.remarkauditchecklist5 = data.data.response.remarkauditchecklist5 || "";
                tempInitialValues.auditcheckliststatus6 = data.data.response.auditcheckliststatus6 || "C";
                tempInitialValues.remarkauditchecklist6 = data.data.response.remarkauditchecklist6 || "";
                tempInitialValues.auditcheckliststatus7 = data.data.response.auditcheckliststatus7 || "C";
                tempInitialValues.remarkauditchecklist7 = data.data.response.remarkauditchecklist7 || "";
                tempInitialValues.auditcheckliststatus8 = data.data.response.auditcheckliststatus8 || "C";
                tempInitialValues.remarkauditchecklist8 = data.data.response.remarkauditchecklist8 || "";
                tempInitialValues.auditcheckliststatus9 = data.data.response.auditcheckliststatus9 || "C";
                tempInitialValues.remarkauditchecklist9 = data.data.response.remarkauditchecklist9 || "";
                tempInitialValues.auditcheckliststatus10 = data.data.response.auditcheckliststatus10 || "C";
                tempInitialValues.remarkauditchecklist10 = data.data.response.remarkauditchecklist10 || "";
                tempInitialValues.auditcheckliststatus11 = data.data.response.auditcheckliststatus11 || "C";
                tempInitialValues.remarkauditchecklist11 = data.data.response.remarkauditchecklist11 || "";
                tempInitialValues.auditcheckliststatus12 = data.data.response.auditcheckliststatus12 || "C";
                tempInitialValues.remarkauditchecklist12 = data.data.response.remarkauditchecklist12 || "";
                tempInitialValues.briefaboutorg = data.data.response.briefaboutorg || "";
                tempInitialValues.teamleadervalue1 = data.data.response.teamleadervalue1 || "Yes";
                tempInitialValues.teamleadervalue2 = data.data.response.teamleadervalue2 || "Yes";
                tempInitialValues.teamleadervalue3 = data.data.response.teamleadervalue3 || "Yes";
                tempInitialValues.teamleadervalue4 = data.data.response.teamleadervalue4 || "Yes";
                tempInitialValues.teamleadervalue5 = data.data.response.teamleadervalue5 || "Yes";
                tempInitialValues.teamleadervalue6 = data.data.response.teamleadervalue6 || "Yes";
                tempInitialValues.teamleadervalue7 = data.data.response.teamleadervalue7 || "Yes";
                tempInitialValues.teamleadervalue8 = data.data.response.teamleadervalue8 || "Yes";
                tempInitialValues.teamleadervalue9 = data.data.response.teamleadervalue9 || "Yes";
                tempInitialValues.recommededvalue1 = data.data.response.recommededvalue1 || "Yes";
                tempInitialValues.recommededvalue2 = data.data.response.recommededvalue2 || "Yes";
                tempInitialValues.recommededvalue3 = data.data.response.recommededvalue3 || "Yes";

                setInitialValues(tempInitialValues)
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationLeadAudiorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationAssisAuditorDetails.mutate(tempInitialValues.nacecode)
                }
                if (tempInitialValues.nacecode && tempInitialValues.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempInitialValues.nacecode)
                }

               

            } else {
                var msg = 'Company - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Get Company Details' + error)
        }
    })
    const mutationAssisAuditorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforAssistAuditorCommonNacecode/' + params, {}), {
        onSuccess(data) {

            if (data.data.errorCode === 0) {
                console.log("List of ast Auditor", data.data.response)
                setassitAuditorList(data.data.response)
                
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationLeadAudiorDetails = useMutation((params) => Fetcher('get', '/api/profile/get/keyvalueforleadauditorsCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("Laead Auditor List", data)
            if (data.data.errorCode === 0) {
                console.log("List of Auditor", data.data.response)
                setLeadauditorList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    const mutationTechnicalExpertDetails = useMutation((params) => Fetcher('get', '/api/technicalexpert/get/labelvalueTechnicalExpertCommonNacecode/' + params, {}), {
        onSuccess(data) {
            console.log("data expert",data)
            
            if (data.data.errorCode === 0) {
                console.log("List of Technical Expert",data.data.response)
                setTechnicalExpertList(data.data.response)
            } else {
                var msg = 'Subject - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Subject' + error)
        }
    })
    
    const { orgcode } = useParams()
   
    const { data: orgList, isLoading: companyListLoading } = useQuery(
        'emsstage1auditreport',
        () => Fetcher('get', '/api/clientaccess/get/listofcompaniesemsstage1audreport14001/' + localStorage.getItem("userCode"), {}))
    
    const getUrl = () =>{
        const api= APIURL + '/api/rfq/get/orgdetails/' +orgcode
        axios.get(api , { headers: {"Authorization" : 'Bearer ' + localStorage.getItem("token")} })
        .then(Rfqdata=>{
            if (Rfqdata && initialValues.orgCode === 0 && Rfqdata.data.response.masteragreementStatus === true) {
                var tempData = Rfqdata.data.response
                tempData.dateofaudit = Date.parse(tempData.dateofaudit);
                tempData.auditdate1 = Date.parse(tempData.auditdate1);
                tempData.auditdate2 = Date.parse(tempData.auditdate2);
                setInitialValues(tempData)
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationLeadAudiorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nabcbcode && tempData.nabcbcode !== "") {
                    mutationAssisAuditorDetails.mutate(tempData.nabcbcode)
                }
                if (tempData.nacecode && tempData.nacecode !== "") {
                    mutationTechnicalExpertDetails.mutate(tempData.nacecode)
                }

            }
        })
        .catch(err=>{
            var string= JSON.stringify(err).split("/")[0]
            const regex = /401/g;
            const found = string.match(regex);
            
            console.log("found",found);
            if(found !== null){
                console.log(err)
                window.location.href = "/signin"
            }
        })
    }
   
    useEffect(() => {
        if(orgcode!== undefined){
            getUrl()
        }
       
    }, [orgcode!== undefined])

    if (companyListLoading) return <h1>Loading</h1>
    // ISO 14001:2015
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
           // validationSchema={validationSchema}
           onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper">
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">

                                                    <div className="formOuterDiv">

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='selectNACECode' type='text' options={orgList.data.response} label='Client Name' name='orgCode' onChange={e => { mutationgetCompanyDetails.mutate(e.value); }} />
                                                        </div>

                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Address' name='address' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Site Address' name='siteofaddress' />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='No. of employees' name='total' disabled={true} />
                                                            
                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Mobile' name='mobile' disabled={true} />
                                                            <FormikControl control='input' type="text" label='Email' name='email' disabled={true} />
                                                        </div>
                                                        
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='input' type="text" label='Contact Person Name *' name='contactPersonName' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Scope of Application' name='scope' disabled={true} />
                                                        </div> 
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Technical Area' name='texchnicalarea' />
                                                        </div> 
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Non Applicability of the clause , if any' name='nonappofclauseifany' />
                                                        </div> 
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Legal, Statutory and Regulatory requirements for company.' name='legalstatandregreqforcomp' />
                                                        </div>                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Team</h5>
                                                        </div>                                                       
                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="teamleader" label="Team Leader/ Lead Auditor *" options={leadauditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`teamleader`,parseInt(e.value))
                                                                    formik.setFieldValue(`teamleaderName`, e.label)
                                                                }}
                                                            />

                                                            <FormikControl control='selectNACECode'  label='Technical Expert'  options={technicalExpertList}   name='technicalexpert'
                                                                     onChange={(e) => {
                                                                            
                                                                        formik.setFieldValue(`technicalexpert`, e.value)
                                                                        formik.setFieldValue(`technicalExpertName`, e.label)
                                                                    }}
                                                                       
                                                                    values={(technicalExpertList).find(i => i.value === `technicalexpert`)} />
                                                           
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control="selectNACECode" name="auditorOne" label='Auditor One' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorOne`, parseInt(e.value))
                                                                    formik.setFieldValue(`auditorOneName`, e.label)
                                                                }}
                                                            />
                                                            <FormikControl control="selectNACECode" name="auditorTwo" label='Auditor Two' options={assitAuditorList}
                                                                onChange={(e) => {
                                                                    formik.setFieldValue(`auditorTwo`, e.value)
                                                                    formik.setFieldValue(`auditorTwoName`, e.label)
                                                                }}
                                                            />

                                                        </div>
                                                        
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit Mandays</h5>
                                                        </div>


                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Stage 1 Mandays *' name='stageOneAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label='Stage 1 Audit Date *' name='auditdate1' dateFormat="dd-MM-yyyy"  />
                                                        </div>

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type='text' label='Stage 2 Mandays *' name='stageTwoAudit' style={{textAlign:"right"}} />
                                                            <FormikControl control='date' type='text' label='Stage 2 Audit Date *' name='auditdate2' dateFormat="dd-MM-yyyy" />
                                                        </div>
                                                        <div className="form2RowDiv">
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit From' name='dateofaudit' disabled={true}/>
                                                        <FormikControl control='date' dateFormat="dd-MM-yyyy" label='Date Of Audit To' name='dateofauditto' />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                            <FormikControl control='textarea' type='text' label='Audit Objective' name='auditobjective' disabled={true} />
                                                        </div>
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg' label='Brief about the organization *' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Change Details</h5>
                                                        </div>
                                                        <div className="row">
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Are quoted man-days adequate?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='areqquatedmandays' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in employee detail after application?
                                                                    <span className="required-field"> * </span>
                                                                </label> 
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangeemployee' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any change in Scope?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='istherechangescope' options={options} />
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{ marginLeft: "0.5%" }}>
                                                                <label htmlFor="staticEmail" className="col-sm-9">Is there any information or Event accrued after the application date which may affect the Man-days?
                                                                    <span className="required-field"> * </span>
                                                                </label>
                                                                <div className="col-sm-2 mt-3">
                                                                    <FormikControl control='radio' name='isthereanyinforevent' options={options} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="form1RowDiv">
                                                                <FormikControl control='textarea' type="text" name='briefaboutorg' label='Non Conformities Raised' />
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Team Leader Declaration </h5>
                                                        </div>
                                                        <div className='row'>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">Auditing is based on a sampling process of the available information</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue1' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">Audit is combined, joint or integrated;</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue2' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">The effectiveness of corrective actions taken regarding previously identified</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue3' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">nonconformities has verified</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue4' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">outcomes are effective and complying.</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue5' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">The internal audit and management review process are effective and complying with the requirements.</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue6' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">The scope of certification is appropriate.</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue7' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">The capability of the management system to meet applicable requirements and expected</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue8' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">The audit objectives has been fulfilled and achieved.</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='teamleadervalue9' options={options1} />
                                                                </div>
                                                        </div>
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>RECOMMENDATION </h5>
                                                        </div>
                                                        <div className='row'>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">Recommended Proceeding With Stage 2 (within 60 days from this audit date)</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='recommededvalue1' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">Recommend not proceeding to stage 2 until audit evidence has been submitted to AAP showing that the concerns raised by the auditor (s) have been rectified. A date for stage 2 will then be agreed.</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='recommededvalue2' options={options1} />
                                                                </div>
                                                        </div>
                                                        <div className="row" style={{ marginLeft: "0.5%" }}>
                                                        <label htmlFor="staticEmail" className="col-sm-9">Recommend not proceeding without a further stage 1 Audit due to the severity of the concerns raised by the audit team</label>
                                                                <div className="col-sm-2 mt-3">
                                                                <FormikControl control='radio' name='recommededvalue3' options={options1} />
                                                                </div>
                                                        </div>
                                                        </div>
                                                        <div className="hrstyle headingcolor">
                                                            <h5>Audit CheckList</h5>
                                                        </div>
                                                        <div className="formRowDiv">
                                                                <div className="col-lg-11">
                                                                    <div class="card mb-4">
                                                        <div class="card-body table-responsive">
                                                            <table className="table table-bordered">
                                                                <thead className="table-primary">
                                                                                <tr>
                                                                                    <th>#</th>
                                                                                    <th scope="col" className="text-center" width="50%">REQUIREMENTS</th>
                                                                                    <th scope="col" className="text-center">Status(C/No/O)</th>
                                                                                    <th scope="col" className="text-center">Comments</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-center">1</td>
                                                                                    <td className="fontcontractviewtable">Is the Information is documented as required as per the ISO 14001:2018?</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus1' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist1' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">2</td>
                                                                                    <td className="fontcontractviewtable">Has the discussion held with personnel of the Client company for readiness for stage-2?</td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus2' type="text" style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist2' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">3</td>
                                                                                    <td className="fontcontractviewtable">Is Organization understand the Context of organization with expectation of workers and interested parties
                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus3' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist3' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">4</td>
                                                                                    <td className="fontcontractviewtable">Has the Client site specific conditions are evaluated and safe and secure for workers for their health & safety?
                                                                                    </td>
                                                                                    <td><FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus4' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist4' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">5</td>
                                                                                    <td className="fontcontractviewtable">Has the client documented the EMS Policy and Objectives </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus5' style={{ textAlign: "center" }} /></td>

                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist5' /> </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">6</td>
                                                                                    <td className="fontcontractviewtable">Is the scope is having boundaries and documented as per the clause 4.1 and 4.2?
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus6' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist6' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">7</td>
                                                                                    <td className="fontcontractviewtable">Has client identified Legal and Statutory Requirements applicable  and complied therewith?
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus7' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist7' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">8</td>
                                                                                    <td className="fontcontractviewtable">Is organization has determined, established and maintained the  process for<br/>
                                                                                                <li>Consultation and Participation of Workers</li>
                                                                                                <li>emergency preparedness</li>
                                                                                                <li>Monitoring Measurement and analysis</li> 
                                                                                                <li>Evaluation of Compliances</li>
                                                                                                <li>Incident Investigation and Non conformity</li>
                                                                                                <li>Communication</li>  
                                                                                                <li>Procurement</li>

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus8' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist8' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">9</td>
                                                                                    <td className="fontcontractviewtable">Is the resource are adequate for stage 2 audit?
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus9' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist9' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">10</td>
                                                                                    <td className="fontcontractviewtable">Has  the organization identified the Hazards, risk and Opportunities ?
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus10' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist10' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">11</td>
                                                                                    <td className="fontcontractviewtable">Are Internal audits conducted as planned and effective? Date of Last Internal Audit?
                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus11' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist11' /> </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-center">12</td>
                                                                                    <td className="fontcontractviewtable">Are Management reviews conducted as planned and effective? Date of Last MRM?

                                                                                    </td>
                                                                                    <td> <FormikControl control='selecttable' options={yesNo} name='auditcheckliststatus12' style={{ textAlign: "center" }} /></td>
                                                                                    <td><FormikControl control='inputtable' type="text" name='remarkauditchecklist12' /> </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>


                                                    </div>



                                                        
                                                        <div >

                                                            
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>


                    <div className="card-footer">
                        <div className="row">
                            <div className="col-sm-10"></div>
                            <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary float-right" disabled={!formik.isValid}>Submit</button>
                            </div>

                        </div>
                    </div>
                </Form>
            }
        </Formik>
    )
}

export default EmsStage1AuditReport